module.exports = __webpack_public_path__ + "img/total-price.1984c7da.svg";